import { z } from 'zod'

export const supportedLanguages = ['en', 'fr', 'es', 'nl'] as const
export type availableLanguages = (typeof supportedLanguages)[number]

export const SupportedLanguage = z.enum(supportedLanguages)
export type SupportedLanguage = z.infer<typeof SupportedLanguage>

export const ExcludeLanguage = <T extends SupportedLanguage>(lang: T) =>
  SupportedLanguage.refine((val) => val !== lang, {
    message: `Language cannot be ${lang}`
  })
export type ExcludeLanguage<T extends SupportedLanguage> = z.infer<
  ReturnType<typeof ExcludeLanguage<T>>
>

const TranslationKey = z.object({
  key: z.string(),
  namespace: z.string()
})

const Translation = TranslationKey.extend({
  text: z.string()
})

export type Translation = z.infer<typeof Translation>

export const TranslateSchema = z.object({
  translations: z.array(Translation),
  sourceLanguage: SupportedLanguage,
  targetLanguage: ExcludeLanguage('en')
})
